import {HttpInterceptorFn} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {ADMIN_APP_ID} from '../models/admin.constants';
import {inject} from '@angular/core';
import {EnvironmentService} from '../services/environment.service';

export const httpHeaderInterceptor: HttpInterceptorFn = (
  req,
  next
) => {
  const timezone = new Date().getTimezoneOffset().toString();
  const environmentService = inject(EnvironmentService);

  if (req.url.startsWith(environment.baseUrl)) {
    const currentEnvironment = environmentService.currentEnvironment$();

    const headers: any = {
      'Request-Origin': ADMIN_APP_ID,
      timeZone: timezone,
    };

    if (!environmentService.isMultiEnvironment()) {
      headers['Request-Environment-Id'] = currentEnvironment?.id?.toString() ?? '';
    }


    const isMultipartContent = req.body instanceof FormData;

    if (typeof req.body === 'string') {
      headers['Content-Type'] = 'text/plain';
    } else if (!req.headers.get('Content-Type') && !isMultipartContent) {
      headers['Content-Type'] = 'application/json';
    }

    req = req.clone({
      setHeaders: headers,
    });
  }

  return next(req);
};
